module.exports = {
      id: "icon-headset-usage",
      viewBox: "0 0 14.219 15.009",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-headset",
      toString: function () {
        return this.url;
      }
    }